import { createFileRoute } from '@tanstack/react-router';

import { TicketingPage } from '@frontend/features/ticketing/components/TicketingPage';

export const Route = createFileRoute('/ticketing/')({
  component: TicketingPage,
});
